import { PInlineNotification } from '@porsche-design-system/components-react';
import { type ErrorMessageBoxProps } from '../default/ErrorMessageBox';

const ErrorMessageBox = ({ message, description }: Omit<ErrorMessageBoxProps, 'icon'>) => (
    <PInlineNotification dismissButton={false} state="error">
        <span slot="heading">{message}</span>
        {description}
    </PInlineNotification>
);
export default ErrorMessageBox;
